import { create } from 'zustand';

/** M8.5 A-07：相机标定向导弹窗开关（DataMenu 入口 → SceneEditor 挂载） */
interface CalibrationState {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

export const useCalibrationStore = create<CalibrationState>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}));

export default useCalibrationStore;
